"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Exception thrown if a callback refers to an undefined method or if some arguments are missing.
 */
class BadMethodCallException extends Error {
    constructor(reason) {
        if (reason.trim().length === 0) {
            super("Bad method call, and no reason, which is also bad method call!");
        }
        else {
            super(reason);
        }
    }
}
exports.default = BadMethodCallException;
//# sourceMappingURL=BadMethodCallException.js.map